/**
 * Check if an object is valid
 * @param obj
 * @returns {boolean}
 */
export const isObjectValid = obj => {
    return obj && typeof obj === 'object' && Object.keys(obj).length > 0;
};

/**
 * Check if an object is filled with the given fields
 * @param {object} obj
 * @param  {...string} fields
 * @returns {boolean}
 */
export const isFilledWith = (obj, ...fields) => {
    return fields.every(field => obj[field]);
};
